module.exports = __webpack_public_path__ + "img/_20241111082403.44e60d70.png";